<template>
  <div id="create-offer-component">
    <button class="btn btn-primary" v-b-modal="'create-offer-modal'">
      <fa-icon :icon="['fas','plus']" class="mr-2" />Erstellen
    </button>
    <b-modal id="create-offer-modal" ref="create-offer-modal" title="Herstelleraktion erstellen" no-close-on-backdrop hide-header-close content-class="shadow" scrollable>
      <label for="name" class="font-weight-bold">Beschreibung</label>
      <b-form-input id="name" v-model="name" class="form-group" placeholder="Herstelleraktion"></b-form-input>

      <label for="period" class="font-weight-bold">Zeitraum</label>
      <b-form-input id="period" v-model="period" class="form-group" placeholder="bis zum 30. September 2020"></b-form-input>

      <label for="link" class="font-weight-bold">Link</label>
      <LinkComponent v-on:linkChanged="linkChanged" :linkProp="link" />

      <label for="language" class="font-weight-bold">Sprache</label>
      <b-form-select id="language" v-model="language" :options="languageOptions" class="form-group"></b-form-select>

      <label class="font-weight-bold">Anzeigezeitraum</label>
      <b-form-group
        label-cols-sm="1"
        label="Von"
        label-for="datepicker-from-date"
      >
        <b-form-datepicker id="datepicker-from-date" v-model="fromDate" :locale="'de-DE'"></b-form-datepicker>
      </b-form-group>
      <b-form-group
        label-cols-sm="1"
        label="Bis"
        label-for="datepicker-to-date"
      >
        <b-form-datepicker id="datepicker-to-date" v-model="toDate" :locale="'de-DE'"></b-form-datepicker>
      </b-form-group>

      <label class="font-weight-bold">Herstellerlogo</label>
      <table class="mb-3 text-muted" cellpadding="2">
        <tbody>
          <tr>
            <td>Bildgröße (px):</td>
            <td>50x50</td>
          </tr>
          <tr>
            <td>Max. Dateigröße (mb):</td>
            <td>1</td>
          </tr>
          <tr>
            <td>Erlaubte Dateiformate:</td>
            <td>jpg, png</td>
          </tr>
        </tbody>
      </table>
      <UploadImageComponent v-on:imageUpload="imageUploaded"  :imageProp="''" />

      <template v-slot:modal-footer>
        <b-button variant="outline-secondary" v-on:click="hideModal">Abbrechen</b-button>
        <SaveButtonComponent :saveButtonSate="saveButtonSate" v-on:submitSaveButton="saveChanges" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import SaveButtonComponent from './SaveButtonComponent'
import UploadImageComponent from './UploadImageComponent'
import LinkComponent from './LinkComponent'
import moment from 'moment-timezone'

import {db} from "../plugins/firebase"
import {set, ref, push, child} from "firebase/database"

import { store } from "../plugins/store"

export default {
  name: 'CreateOfferComponent',
  components: {
    SaveButtonComponent,
    UploadImageComponent,
    LinkComponent
  },
  methods: {
    hideModal: function() {
      this.$refs['create-offer-modal'].hide()
    },
    imageUploaded: function(image) {
      this.imageUrl = image.url
      this.fileName = image.fileName
    },
    saveChanges: function() {
      if (
        this.name === '' ||
        this.period === '' ||
        this.imageUrl === '' ||
        this.fileName === '' ||
        this.fromDate === '' ||
        this.language === '' ||
        this.toDate === ''
      ) {
        store.dispatch("fetchAlert", {
            kind: 'danger',
            message: "Eingabe unvollständig. Bitte die Eingabe-Felder überprüfen!",
            time: false
          })
        return
      }

      this.saveButtonSate = 'saving'

      const document = {
        name: this.name,
        period: this.period,
        link: this.link,
        imageUrl: this.imageUrl,
        fileName: this.fileName,
        fromDate: this.fromDate,
        language: this.language,
        toDate: this.toDate
      }
      const newPostKey = push(child(ref(db), 'offers')).key;
      set(ref(db, 'offers/'+newPostKey), document)
      .then(() => {
        this.saveButtonSate = 'done'
        setTimeout(() => this.hideModal(), 1800)
      })
      .catch(error => {
        this.saveButtonSate = 'error'
         store.dispatch("fetchAlert", {
            kind: 'danger',
            message: error,
            time: false
          })
        console.error(error)
        setTimeout(() => this.saveButtonSate = '', 1800)
      })
    },
    linkChanged: function(data) {
      this.link = data
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', () => {
      this.name = ''
      this.period = ''
      this.link = {
        target: '_blank',
        url: '',
        intValue: '',
        type: 'Extern'
      }
      this.imageUrl = ''
      this.language = 'DE'
      this.saveButtonSate = ''
      this.fileName = ''
      this.fromDate = moment().tz('Europe/Berlin').format('YYYY-MM-DD')
      this.toDate = moment().tz('Europe/Berlin').add(1, 'd').format('YYYY-MM-DD')
    })
  },
  data() {
    return {
      saveButtonSate: '',
      name: '',
      period: '',
      link: {
        target: '_blank',
        url: '',
        intValue: '',
        body: '',
        subject: '',
        type: 'Extern'
      },
      imageUrl: '',
      fileName: '',
      fromDate: moment().tz('Europe/Berlin').format('YYYY-MM-DD'),
      toDate: moment().tz('Europe/Berlin').add(1, 'd').format('YYYY-MM-DD'),
      language: 'DE',
      languageOptions: [
        'DE',
        'EN'
      ]
    }
  }
}
</script>